import { render, staticRenderFns } from "./ImportantInfo.vue?vue&type=template&id=75c7b46c&scoped=true"
import script from "./ImportantInfo.vue?vue&type=script&lang=js"
export * from "./ImportantInfo.vue?vue&type=script&lang=js"
import style0 from "./ImportantInfo.vue?vue&type=style&index=0&id=75c7b46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c7b46c",
  null
  
)

export default component.exports